type AddressParts = {
  address1?: string | null
  address2?: string | null
  zipCode?: string | null
  city?: string | null
}

// Address on one line: street line(s), then zip code and town (e.g. "Manston Road, CT12 5DF Ramsgate").
export const formatFullAddress = ({ address1, address2, zipCode, city }: AddressParts): string => {
  const cityLine = [zipCode, city].filter(Boolean).join(' ')
  return [address1, address2, cityLine].filter(Boolean).join(', ')
}
